import { render, staticRenderFns } from "./stcContactForm.vue?vue&type=template&id=5690945c&scoped=true"
import script from "./stcContactForm.vue?vue&type=script&lang=js"
export * from "./stcContactForm.vue?vue&type=script&lang=js"
import style0 from "./stcContactForm.vue?vue&type=style&index=0&id=5690945c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690945c",
  null
  
)

export default component.exports